import axios from "libs/axios";
import { useQuery } from "react-query";
import { AxiosError } from "axios";
import { useAppDispatch } from "store";
import { setMerchant } from "../slice/merchant";
import { merchantDTO } from "../type";
interface merchantRequest {
  id: string;
}
const merchant = async (data: merchantRequest) => {
  return await axios
    .get<merchantDTO>(`/api/v1/Merchant/get-all-by-userid`, {
      params: { UserId: data.id, version: "1" },
    })
    .then((res) => res.data)
    .catch((err) => err.data);
};

export const useMerchant = (data: merchantRequest) => {
  const dispatch = useAppDispatch();
  return useQuery<merchantDTO, AxiosError>(
    [`/api/v1/Merchant/get-all-by-userid/${data.id}`],
    async () => merchant(data),
    {
      onSuccess: (response) => {
        dispatch(setMerchant(response.data));
      },
    }
  );
};
